import _ from 'lodash';
import moment from 'moment';

export const closingRanges = [
  { key: 'UP_TO_1', text: 'Up to 1', value: moment.duration({ days: 1 }).valueOf() },
  { key: 'UP_TO_7', text: 'Up to 7', value: moment.duration({ days: 7 }).valueOf() },
  { key: 'UP_TO_14', text: 'Up to 14', value: moment.duration({ days: 14 }).valueOf() },
  { key: 'UP_TO_30', text: 'Up to 30', value: moment.duration({ days: 30 }).valueOf() },
  { key: 'UP_TO_NOW', text: 'Up to now', value: moment.duration({ years: 100 }).valueOf() },
  { key: 'CUSTOM', text: 'Custom', custom: true, value: 0 },
  { key: 'PER_STEP_CONFIG', text: 'Per step configuration', global: true },
];

export const defaultClosingRange = _.pick(
  closingRanges.find((cr) => cr.key === 'UP_TO_30'),
  ['value', 'custom']
);

export const perStepClosingRange = _.pick(
  closingRanges.find((cr) => cr.key === 'PER_STEP_CONFIG'),
  ['value']
);

export const stepTypes = {
  POSITIVE: 'POSITIVE',
  LOCAL_NEGATIVE: 'LOCAL_NEGATIVE',
};

export const stepTypesLabels = {
  FIRST: 'Users who did the event',
  POSITIVE: 'and then did the event',
  LOCAL_NEGATIVE: "and then didn't do the event",
};

export const defaultCompoundStepCount = 1;

export const compoundStepCountOperators = {
  EQ: '=',
  LT: '<',
  GT: '>',
  GTE: '>=',
  LTE: '<=',
};

export const defaultCompoundStepCountOperator = compoundStepCountOperators.GTE;
